import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import DormantDevices from './devicesReports/DormantDevices';
import LowBatteryDevices from './devicesReports/LowBatteryDevices';
import MissingDevices from './devicesReports/MissingDevices';
import ActiveTamperDevices from './devicesReports/ActiveTamperDevices';
import { loadAlarmDeviceTypes } from '../../redux/actions/alarmDeviceActions';
import SvgUpArrowIcon from '../svg/UpArrowIcon';

export function UnconnectedDevicesStatusReports(props) {
  const location = useLocation();
  const { search, pathname } = location;
  const searchParams = new URLSearchParams(search);
  const view = searchParams.get('view');
  const currentLocation = pathname + search;

  useEffect(() => {
    props.dispatch(loadAlarmDeviceTypes());
  }, []); // eslint-disable-line

  const dormantDevicesLabel = (
    <FormattedMessage
      id="devicesStatusReports.dormantDevicesLabel"
      defaultMessage="Dormant Devices"
      description="Link to the critical devices report"
    />
  );

  const missingDevicesLabel = (
    <FormattedMessage
      id="devicesStatusReports.missingDevicesLabel"
      defaultMessage="Missing Devices"
      description="Link to the critical devices report"
    />
  );

  const lowBatteryDevicesLabel = (
    <FormattedMessage
      id="devicesStatusReports.lowBatteryDevicesLabel"
      defaultMessage="Low Battery Devices"
      description="Link to the critical devices report"
    />
  );

  const ActiveTamperDevicesLabel = (
    <FormattedMessage
      id="devicesStatusReports.ActiveTamperDevicesLabel"
      defaultMessage="Active Tamper Devices"
      description="Link to the critical devices report"
    />
  );

  const backText = (
    <FormattedMessage
      id="devicesStatusReports.backText"
      defaultMessage="Back to Reports"
      description="Link back to the users interface"
    />
  );

  const devicesStatusReportsText = (
    <FormattedMessage
      id="devicesStatusReports.devicesStatusReportsText"
      defaultMessage="Devices Status Reports"
      description="Link back to the users interface"
    />
  );

  // function to determine which report to display based on the view variable
  function displayReports() {
    switch (view) {
      case 'dormantDevices':
        return (
          <DormantDevices
            data-test="dormant-devices-component"
            currentLocation={currentLocation}
          />
        );
      case 'missingDevices':
        return (
          <MissingDevices
            data-test="missing-devices-component"
            currentLocation={currentLocation}
          />
        );
      case 'activeTamperDevices':
        return (
          <ActiveTamperDevices
            data-test="active-tamper-component"
            currentLocation={currentLocation}
          />
        );

      default:
        return (
          <LowBatteryDevices
            data-test="low-battery-component"
            currentLocation={currentLocation}
          />
        );
    }
  }

  return (
    <div className="container">
      <FormattedMessage
        id="devicesStatusReports.browserTabInfo"
        defaultMessage="Reports | Devices Status"
        description="Done button">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div
        className="layout-container--wide content-container content-container--column content-container--shadow"
        data-test="display-container">
        <div className="width-100 align-center flex-around margin-bottom-10">
          <a
            className="link-text align-center"
            href="/reports/reportscr.php"
            data-test="user-display-cancel-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </a>
        </div>
        <div className="flex-around width-100 margin-bottom-10">
          <h1 className="no-margin text-center" data-test="display-title">
            {devicesStatusReportsText}
          </h1>
        </div>
        <div className="tab-bar" data-test="tab-bar">
          <Link
            to="/reports/devicesStatus/"
            className={
              view === null
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="low-batt-tab">
            {lowBatteryDevicesLabel}
          </Link>

          <Link
            to="/reports/devicesStatus/?view=missingDevices"
            className={
              view === 'missingDevices'
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="missing-devices-tab">
            {missingDevicesLabel}
          </Link>

          <Link
            to="/reports/devicesStatus/?view=activeTamperDevices"
            className={
              view === 'activeTamperDevices'
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="active-tamper-tab">
            {ActiveTamperDevicesLabel}
          </Link>
          <Link
            to="/reports/devicesStatus/?view=dormantDevices"
            className={
              view === 'dormantDevices'
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="dormant-tab">
            {dormantDevicesLabel}
          </Link>
        </div>
        {displayReports()}
        <div className="width-100 align-center flex-around margin-bottom-10">
          <a
            className="link-text align-center"
            href="/reports/reportscr.php"
            data-test="user-display-cancel-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </a>
        </div>
      </div>
    </div>
  );
}

export default connect()(UnconnectedDevicesStatusReports);
